module.exports = __webpack_public_path__ + "static/media/CaretDoubleDown.c4dec984.svg";